import { useContext } from 'react';
import { MessagingContext } from './context';

export const useMessaging = () => {
  const value = useContext(MessagingContext);
  if (!value) throw new Error('MessagingProvider is required');
  return value;
};
